<template>
  <v-expansion-panels v-model="panelesAbiertos" multiple accordion>
    <v-expansion-panel v-for="grupo in preguntas" :key="grupo.pregunta.id">
      <v-expansion-panel-header>
        <div class="d-flex align-center pr-4 panel-header">
          <div>
            <div class="font-weight-bold">{{ tituloPregunta(grupo.pregunta) }}</div>
            <div class="text-caption text--secondary">
              {{ grupo.total_respuestas }} {{ grupo.total_respuestas === 1 ? 'respuesta' : 'respuestas' }}
            </div>
          </div>
          <v-spacer />
          <v-chip small color="amber lighten-4" text-color="amber darken-4" class="font-weight-bold">
            <v-icon left small color="amber darken-2">mdi-star</v-icon>
            {{ formatearValoracion(grupo.valoracion) }}
          </v-chip>
        </div>
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <div v-if="textoPregunta(grupo.pregunta)" class="mb-4 text--secondary">
          {{ textoPregunta(grupo.pregunta) }}
        </div>

        <v-data-table
          dense
          locale="es"
          class="elevation-1 alternating-rows bordered-table"
          :headers="headers"
          :items="grupo.respuestas"
          item-key="id"
          :items-per-page="-1"
          hide-default-footer
          no-data-text="No hay respuestas para esta pregunta."
        >
          <template v-slot:[`item.puntuacion`]="{ item }">
            <v-chip
              v-if="item.puntuacion !== null"
              x-small
              color="amber lighten-4"
              text-color="amber darken-4"
              class="font-weight-bold"
            >
              <v-icon left x-small>mdi-star</v-icon>
              {{ item.puntuacion }}/10
            </v-chip>
            <span v-else class="text--disabled">—</span>
          </template>
          <template v-slot:[`item.comentario`]="{ item }">
            <span v-if="item.comentario" class="comentario-texto">{{ item.comentario }}</span>
            <span v-else class="text-caption text--disabled font-italic">Sin comentario</span>
          </template>
          <template v-slot:[`item.cliente`]="{ item }">
            {{ nombreCliente(item.cliente) }}
          </template>
          <template v-slot:[`item.reserva`]="{ item }">
            {{ item.reserva ? codigoReserva(item.reserva) : '—' }}
          </template>
          <template v-slot:[`item.fecha_prestacion`]="{ item }">
            {{ formatearFecha(item.fecha_prestacion) || '—' }}
          </template>
          <template v-slot:[`item.enviada_at`]="{ item }">
            {{ formatearFecha(item.enviada_at) || '—' }}
          </template>
        </v-data-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: "ValoracionesPreguntas",

  data: () => ({
    panelesAbiertos: [],
    headers: [
      { text: "VALORACIÓN", value: "puntuacion", width: 115, sortable: false },
      { text: "COMENTARIO", value: "comentario", sortable: false },
      { text: "CLIENTE", value: "cliente", sortable: false },
      { text: "RESERVA", value: "reserva", width: 130, sortable: false },
      { text: "FECHA", value: "fecha_prestacion", width: 150, sortable: false },
      //{ text: "FECHA OPINIÓN", value: "enviada_at", width: 140, sortable: false },
    ],
  }),

  props: {
    preguntas: {
      type: Array,
      required: true,
    },
  },

  watch: {
    preguntas: {
      immediate: true,
      handler(preguntas) {
        this.panelesAbiertos = preguntas.map((pregunta, index) => index);
      },
    },
  },

  methods: {
    formatearValoracion(valoracion) {
      if (valoracion === null || valoracion === undefined) return "Sin valorar";
      return `${Number(valoracion).toFixed(1).replace(".", ",")} / 10`;
    },

    tituloPregunta(pregunta) {
      return pregunta.titulo_ES || pregunta.pregunta_ES || `Pregunta ${pregunta.id}`;
    },

    textoPregunta(pregunta) {
      return pregunta.pregunta_ES && pregunta.pregunta_ES !== pregunta.titulo_ES
        ? pregunta.pregunta_ES
        : "";
    },

    codigoReserva(reserva) {
      return reserva.codigo_reserva || reserva.codigo || `#${reserva.id}`;
    },

    nombreCliente(cliente) {
      if (!cliente) return "—";
      return [cliente.nombre, cliente.apellidos].filter(Boolean).join(" ") || `Cliente #${cliente.id}`;
    },

    formatearFecha(fecha) {
      if (!fecha) return "";
      return new Intl.DateTimeFormat("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }).format(new Date(fecha));
    },
  },
};
</script>

<style scoped>
.panel-header {
  width: 100%;
}

.comentario-texto {
  color: rgba(0, 0, 0, 0.78);
  white-space: pre-line;
}

.alternating-rows ::v-deep tbody tr:nth-child(even) {
  background-color: #ebebeb !important;
}

.bordered-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.bordered-table ::v-deep th,
.bordered-table ::v-deep td {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep th:last-child,
.bordered-table ::v-deep td:last-child {
  border-right: none !important;
}

.bordered-table ::v-deep tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep td {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  white-space: normal;
  overflow-wrap: anywhere;
}
</style>
